import * as React from "react";
const SvgFiRrPlanStrategy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plan-strategy_svg__a)">
      <path
        fill="#062147"
        d="M.293 4.293 1.586 3 .293 1.707A.999.999 0 1 1 1.707.293L3 1.586 4.293.293a.999.999 0 1 1 1.414 1.414L4.414 3l1.293 1.293a.999.999 0 1 1-1.414 1.414L3 4.414 1.707 5.707a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414m9 6.414a.997.997 0 0 0 1.414 0L12 9.414l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.414 8l1.293-1.293a.999.999 0 1 0-1.414-1.414L12 6.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L10.586 8 9.293 9.293a1 1 0 0 0 0 1.414m11.414 7.586a1 1 0 0 0-1.414 0L18 19.586l-1.293-1.293a.999.999 0 1 0-1.414 1.414L16.586 21l-1.293 1.293a.999.999 0 1 0 1.414 1.414L18 22.414l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L19.414 21l1.293-1.293a1 1 0 0 0 0-1.414m3.014-14.1a.997.997 0 0 1-1.413.028L21 2.965V11c0 2.206-1.794 4-4 4H6.504a2.004 2.004 0 0 0-2 1.992v.172C5.942 17.6 7 18.921 7 20.5 7 22.43 5.43 24 3.5 24S0 22.43 0 20.5c0-1.58 1.061-2.905 2.503-3.338v-.178A4.01 4.01 0 0 1 6.504 13H17c1.103 0 2-.897 2-2V2.972l-1.308 1.25a.999.999 0 1 1-1.385-1.443L18.608.57c.761-.76 2.021-.76 2.798.014l2.286 2.197a1 1 0 0 1 .028 1.414zM3.501 19c-.828 0-1.5.673-1.5 1.5S2.672 22 3.5 22c.826 0 1.5-.673 1.5-1.5S4.326 19 3.5 19"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plan-strategy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlanStrategy;
